import { FC, useState } from 'react';
// import { Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import DataRow from '@/libs/antd/components/DataRow';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { getCustomerGroupDetail, CustomerGroup, CustomerGroupLocalMember, CustomerGroupCorporateCustomer, CustomerGroupRetailCustomer, CustomerGroupEstarMember } from '@/libs/fleet-api/services/customer';
import { formatNPWPValue } from '@/libs/antd/formater';
import { formatCurrency } from '@/libs/antd/formater';
import dayjs from 'dayjs';
import { Row, Col, Tabs, Divider, Table } from 'antd';
// import { Table } from 'antd';

export type CustomerGroupDetailModalState = null | {
	customerGroupId: number | string;
};

export type CustomerGroupDetailModalProps = {
	modal: CustomerGroupDetailModalState;
	onClose: () => void;
};

const CustomerGroupDetailModal: FC<CustomerGroupDetailModalProps> = ({
	modal,
	onClose,
}) => {
	const { data, isLoading } = useQuery({
		queryKey: ['getCustomerGroupDetail', modal?.customerGroupId] as const,
		queryFn: ({ queryKey }) => {
			const [, id] = queryKey;
			if (!id) return null;
			return getCustomerGroupDetail(id as unknown as string);
		},
		staleTime: 0,
	});

	const {
		id,
		name,
		// address,
		// creditLimit,
		// isActive
		address,
		startDate,
		customerGroupSummary,
		customerList,
		outstandingPrincipalDetail,
	} = (data?.data ?? {}) as Partial<CustomerGroup>;

	const {
		// financingLimit,
		// nonRevolvingFinancingLimit,
		// nonRevolvingNtf,
		// nonRevolvingOutstandingPrincipal,
		// nonRevolvingRemainingLimit,
		// revolvingFinancingLimit,
		// revolvingNtf,
		// revolvingOutstandingPrincipal,
		// revolvingRemainingLimit,
		jfFinancingLimit,
		jfNonRevolvingFinancingLimit,
		jfNonRevolvingNtf,
		jfNonRevolvingOutstandingPrincipal,
		jfNonRevolvingRemainingLimit,
		jfNtf,
		jfOutstandingPrincipal,
		jfRemainingLimit,
		jfRevolvingFinancingLimit,
		jfRevolvingNtf,
		jfRevolvingOutstandingPrincipal,
		jfRevolvingRemainingLimit,
		njfRevolvingFinancingLimit,
		njfNonRevolvingFinancingLimit,
		njfNonRevolvingNtf,
		njfNonRevolvingOutstandingPrincipal,
		njfNonRevolvingRemainingLimit,
		njfNtf,
		njfOutstandingPrincipal,
		njfRemainingLimit,
		njfFinancingLimit,
		njfRevolvingNtf,
		njfRevolvingOutstandingPrincipal,
		njfRevolvingRemainingLimit,
	} = customerGroupSummary ?? {};

	// const customerListColumns = [
	// 	{
	// 		title: 'Customer ID',
	// 		dataIndex: 'customerId',
	// 	},
	// 	{
	// 		title: 'Customer Name',
	// 		dataIndex: 'customerName',
	// 	},
	// 	{
	// 		title: 'JF Financing Limit',
	// 		dataIndex: 'jfFinancingLimit',
	// 		render: (value: number) => (value ? formatCurrency(value) : '-'),
	// 	},
	// 	{
	// 		title: 'NJF Financing Limit',
	// 		dataIndex: 'njfFinancingLimit',
	// 		render: (value: number) => (value ? formatCurrency(value) : '-'),
	// 	},
	// 	{
	// 		title: 'NPWP',
	// 		dataIndex: 'npwp',
	// 	},
	// 	{
	// 		title: 'Outstanding Principal',
	// 		dataIndex: 'outstandingPrincipal',
	// 		render: (value: number) => (value ? formatCurrency(value) : '-'),
	// 	},
	// 	{
	// 		title: 'Total Financing Limit',
	// 		dataIndex: 'totalFinancingLimit',
	// 		render: (value: number) => (value ? formatCurrency(value) : '-'),
	// 	},
	// 	{
	// 		title: 'Total JF Outstanding',
	// 		dataIndex: 'totalJfOutstanding',
	// 		render: (value: number) => (value ? formatCurrency(value) : '-'),
	// 	},
	// 	{
	// 		title: 'Total NJF Outstanding',
	// 		dataIndex: 'totalNjfOutstanding',
	// 		render: (value: number) => (value ? formatCurrency(value) : '-'),
	// 	},
	// 	{
	// 		title: 'Total Outstanding',
	// 		dataIndex: 'totalOutstanding',
	// 		render: (value: number) => (value ? formatCurrency(value) : '-'),
	// 	},
	// ];

	return (
		<FleetModal
			open={Boolean(modal)}
			width={940}
			cancelText="BACK"
			buttonPosition="end"
			closable={false}
			okButtonProps={{
				hidden: true,
			}}
			onCancel={() => onClose?.()}
		>
			<FleetTitle>Customer Group BMPP</FleetTitle>
			<DataRow
				loading={isLoading}
				items={[
					[
						['Group ID', id],
						['Group Name', name],
					],
					[
						[
							'Tanggal Terdaftar',
							startDate ? dayjs(startDate).format('DD MMM YYYY') : '-',
						],
						['Alamat Group', address],
					],
					// [
					// 	['Total NTF', totalNtf ? formatCurrency(totalNtf) : '-'],
					// 	['Total Plafon', totalPlafon ? formatCurrency(totalPlafon) : '-'],
					// ],
				]}
				style={{
					marginBottom: 20,
				}}
			/>
			<Divider />
			<Tabs
				defaultActiveKey="1"
				items={[
					{
						label: 'Group BMPP Summary View',
						key: 'groupExposure',
						children: (
							<>
								<Row gutter={16}>
									<Col span={8}>
										<p>
											<strong>Limit</strong>
										</p>
										<p>Revolving</p>
										<p>Non-Revolving</p>
										<p>
											<strong>Total</strong>
										</p>
									</Col>
									<Col span={8}>
										<p>
											<strong>JF</strong>
										</p>
										<p>
											{jfRevolvingFinancingLimit
												? formatCurrency(jfRevolvingFinancingLimit)
												: '-'}
										</p>
										<p>
											{jfNonRevolvingFinancingLimit
												? formatCurrency(jfNonRevolvingFinancingLimit)
												: '-'}
										</p>
										<p>
											<strong>
												{jfFinancingLimit
													? formatCurrency(jfFinancingLimit)
													: '-'}
											</strong>
										</p>
									</Col>
									<Col span={8}>
										<p>
											<strong>NJF</strong>
										</p>
										<p>
											{njfRevolvingFinancingLimit
												? formatCurrency(njfRevolvingFinancingLimit)
												: '-'}
										</p>
										<p>
											{njfNonRevolvingFinancingLimit
												? formatCurrency(njfNonRevolvingFinancingLimit)
												: '-'}
										</p>
										<p>
											<strong>
												{njfFinancingLimit
													? formatCurrency(njfFinancingLimit)
													: '-'}
											</strong>
										</p>
									</Col>
								</Row>
								<Divider />
								<Row gutter={16}>
									<Col span={8}>
										<p>
											<strong>NTF</strong>
										</p>
										<p>Revolving</p>
										<p>Non-Revolving</p>
										<p>
											<strong>Total</strong>
										</p>
									</Col>
									<Col span={8}>
										<p>
											<strong>JF</strong>
										</p>
										<p>
											{jfRevolvingNtf ? formatCurrency(jfRevolvingNtf) : '-'}
										</p>
										<p>
											{jfNonRevolvingNtf
												? formatCurrency(jfNonRevolvingNtf)
												: '-'}
										</p>
										<p>
											<strong>{jfNtf ? formatCurrency(jfNtf) : '-'}</strong>
										</p>
									</Col>
									<Col span={8}>
										<p>
											<strong>NJF</strong>
										</p>
										<p>
											{njfRevolvingNtf ? formatCurrency(njfRevolvingNtf) : '-'}
										</p>
										<p>
											{njfNonRevolvingNtf
												? formatCurrency(njfNonRevolvingNtf)
												: '-'}
										</p>
										<p>
											<strong>{njfNtf ? formatCurrency(njfNtf) : '-'}</strong>
										</p>
									</Col>
								</Row>
								<Divider />
								<Row gutter={16}>
									<Col span={8}>
										<p>
											<strong>Outstanding Principal</strong>
										</p>
										<p>Revolving</p>
										<p>Non-Revolving</p>
										<p>
											<strong>Total</strong>
										</p>
									</Col>
									<Col span={8}>
										<p>
											<strong>JF</strong>
										</p>
										<p>
											{jfRevolvingOutstandingPrincipal
												? formatCurrency(jfRevolvingOutstandingPrincipal)
												: '-'}
										</p>
										<p>
											{jfNonRevolvingOutstandingPrincipal
												? formatCurrency(jfNonRevolvingOutstandingPrincipal)
												: '-'}
										</p>
										<p>
											<strong>
												{jfOutstandingPrincipal
													? formatCurrency(jfOutstandingPrincipal)
													: '-'}
											</strong>
										</p>
									</Col>
									<Col span={8}>
										<p>
											<strong>NJF</strong>
										</p>
										<p>
											{njfRevolvingOutstandingPrincipal
												? formatCurrency(njfRevolvingOutstandingPrincipal)
												: '-'}
										</p>
										<p>
											{njfNonRevolvingOutstandingPrincipal
												? formatCurrency(njfNonRevolvingOutstandingPrincipal)
												: '-'}
										</p>
										<p>
											<strong>
												{njfOutstandingPrincipal
													? formatCurrency(njfOutstandingPrincipal)
													: '-'}
											</strong>
										</p>
									</Col>
								</Row>
								<Divider />
								<Row gutter={16}>
									<Col span={8}>
										<p>
											<strong>Sisa Plafond</strong>
										</p>
										<p>Revolving</p>
										<p>Non-Revolving</p>
										<p>
											<strong>Total</strong>
										</p>
									</Col>
									<Col span={8}>
										<p>
											<strong>JF</strong>
										</p>
										<p>
											{jfRevolvingRemainingLimit
												? formatCurrency(jfRevolvingRemainingLimit)
												: '-'}
										</p>
										<p>
											{jfNonRevolvingRemainingLimit
												? formatCurrency(jfNonRevolvingRemainingLimit)
												: '-'}
										</p>
										<p>
											<strong>
												{jfRemainingLimit
													? formatCurrency(jfRemainingLimit)
													: '-'}
											</strong>
										</p>
									</Col>
									<Col span={8}>
										<p>
											<strong>NJF</strong>
										</p>
										<p>
											{njfRevolvingRemainingLimit
												? formatCurrency(njfRevolvingRemainingLimit)
												: '-'}
										</p>
										<p>
											{njfNonRevolvingRemainingLimit
												? formatCurrency(njfNonRevolvingRemainingLimit)
												: '-'}
										</p>
										<p>
											<strong>
												{njfRemainingLimit
													? formatCurrency(njfRemainingLimit)
													: '-'}
											</strong>
										</p>
									</Col>
								</Row>
							</>
						),
					},
					{
						label: 'Member of Group',
						key: 'customerList',
						children: (
							<>
								<FleetTitle level={3}>Corporate Fleet Customers</FleetTitle>
								<Table
									scroll={{ x: 'max-content' }}
									dataSource={
										customerList?.corporates?.map((record, key) => {
											return { ...record, key };
										}) ?? []
									}
									pagination={false}
									columns={[
										{
											title: 'No',
											render: (_, _record, index) => index + 1,
										},
										{
											title: 'Customer ID',
											dataIndex: 'customerId',
										},
										{
											title: 'Customer Name',
											dataIndex: 'customerName',
										},
										{
											title: 'NPWP',
											dataIndex: 'npwpNo',
										},
										{
											title: 'Kelompok BMPP',
											render: (_: unknown, record: CustomerGroupCorporateCustomer) =>
												record.relationshipDescription ?? '-',
										},
										{
											title: 'Limit Pembiayaan JF',
											render: (_, record) =>
												record.jfFinancingLimit
													? formatCurrency(record.jfFinancingLimit)
													: '-',
										},
										{
											title: 'Limit Pembiayaan NJF',
											render: (_, record) =>
												record.njfFinancingLimit
													? formatCurrency(record.njfFinancingLimit)
													: '-',
										},
										{
											title: 'Total Limit Pembiayaan',
											render: (_, record) =>
												record.totalFinancingLimit
													? formatCurrency(record.totalFinancingLimit)
													: '-',
										},
										{
											title: 'Total Outstanding JF',
											render: (_, record) =>
												record.jfOutstandingPrincipal
													? formatCurrency(record.jfOutstandingPrincipal)
													: '-',
										},
										{
											title: 'Total Outstanding NJF',
											render: (_, record) =>
												record.njfOutstandingPrincipal
													? formatCurrency(record.njfOutstandingPrincipal)
													: '-',
										},
										{
											title: 'Total Outstanding',
											render: (_, record) =>
												record.totalOutstandingPrincipal
													? formatCurrency(record.totalOutstandingPrincipal)
													: '-',
										},
									]}
									style={{ marginBottom: 20 }}
								/>
								<FleetTitle level={3}>Retail Customers</FleetTitle>
								<Table
									scroll={{ x: 'max-content' }}
									dataSource={
										customerList?.retails?.map((record, key) => {
											return { ...record, key };
										}) ?? []
									}
									pagination={false}
									columns={[
										{
											title: 'No',
											render: (_, _record, index) => index + 1,
										},
										{
											title: 'Customer ID',
											dataIndex: 'customerId',
										},
										{
											title: 'Customer Name',
											dataIndex: 'customerName',
										},
										{
											title: 'JF Status',
										},
										{
											title: 'NPWP',
											dataIndex: 'npwpNo',
										},
										{
											title: 'Kelompok BMPP',
											render: (_: unknown, record: CustomerGroupRetailCustomer) =>
												record.relationshipDescription ?? '-',
										},
										{
											title: 'NTF Total',
											render: (_, record) =>
												record.totalNtf ? formatCurrency(record.totalNtf) : '-',
										},
										{
											title: 'OS Total',
											render: (_, record) =>
												record.totalOutstandingPrincipal
													? formatCurrency(record.totalOutstandingPrincipal)
													: '-',
										},
									]}
								/>
								<FleetTitle level={3} style={{ marginTop: 20 }}>Customer LOS</FleetTitle>
								<Table
									scroll={{ x: 'max-content' }}
									dataSource={
										customerList?.locals?.map((record: CustomerGroupLocalMember, key: number) => {
											return { ...record, key };
										}) ?? []
									}
									pagination={false}
									columns={[
										{
											title: 'No',
											render: (_: unknown, __: unknown, index: number) => index + 1,
										},
										{
											title: 'Customer ID',
											dataIndex: 'customerId',
										},
										{
											title: 'Customer Name',
											dataIndex: 'customerName',
										},
										{
											title: 'NPWP',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.npwpNo ? formatNPWPValue(record.npwpNo) : '-',
										},
										{
											title: 'Kelompok BMPP',
											dataIndex: 'relationshipDescription',
											render: (val: string) => val ?? '-',
										},
										{
											title: 'Limit Pembiayaan JF',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.jfFinancingLimit
													? formatCurrency(record.jfFinancingLimit)
													: '-',
										},
										{
											title: 'Limit Pembiayaan NJF',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.njfFinancingLimit
													? formatCurrency(record.njfFinancingLimit)
													: '-',
										},
										{
											title: 'NTF JF',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.jfNtf
													? formatCurrency(record.jfNtf)
													: '-',
										},
										{
											title: 'NTF NJF',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.njfNtf
													? formatCurrency(record.njfNtf)
													: '-',
										},
										{
											title: 'OS Principal JF',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.jfOutstandingPrincipal
													? formatCurrency(record.jfOutstandingPrincipal)
													: '-',
										},
										{
											title: 'OS Principal NJF',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.njfOutstandingPrincipal
													? formatCurrency(record.njfOutstandingPrincipal)
													: '-',
										},
										{
											title: 'Total Limit Pembiayaan',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.totalFinancingLimit
													? formatCurrency(record.totalFinancingLimit)
													: '-',
										},
										{
											title: 'Total Outstanding',
											render: (_: unknown, record: CustomerGroupLocalMember) =>
												record.totalOutstandingPrincipal
													? formatCurrency(record.totalOutstandingPrincipal)
													: '-',
										},
									]}
								/>
								{(customerList?.estars?.length ?? 0) > 0 && (
									<>
										<FleetTitle level={3} style={{ marginTop: 20 }}>Estar Customers</FleetTitle>
										<Table
											scroll={{ x: 'max-content' }}
											dataSource={
												customerList?.estars?.map((record: CustomerGroupEstarMember, key: number) => {
													return { ...record, key };
												}) ?? []
											}
											pagination={false}
											columns={[
												{
													title: 'No',
													render: (_: unknown, __: unknown, index: number) => index + 1,
												},
												{
													title: 'Customer ID',
													dataIndex: 'customerId',
												},
												{
													title: 'Customer Name',
													dataIndex: 'customerName',
												},
												{
													title: 'NPWP',
													render: (_: unknown, record: CustomerGroupEstarMember) =>
														record.npwpNo ? formatNPWPValue(record.npwpNo) : '-',
												},
												{
													title: 'Kelompok BMPP',
													render: (_: unknown, record: CustomerGroupEstarMember) =>
														record.relationshipDescription ?? '-',
												},
												{
													title: 'Limit Pembiayaan JF',
													render: () => '-',
												},
												{
													title: 'Limit Pembiayaan NJF',
													render: () => '-',
												},
												{
													title: 'Total Limit Pembiayaan',
													render: (_: unknown, record: CustomerGroupEstarMember) =>
														record.maxOsBalance
															? formatCurrency(record.maxOsBalance)
															: '-',
												},
												{
													title: 'Total Outstanding JF',
													render: () => '-',
												},
												{
													title: 'Total Outstanding NJF',
													render: () => '-',
												},
												{
													title: 'Total Outstanding',
													render: (_: unknown, record: CustomerGroupEstarMember) =>
														record.osPrincipal
															? formatCurrency(record.osPrincipal)
															: '-',
												},
											]}
										/>
									</>
								)}
							</>
						),
					},
					{
						label: 'Outstanding Principal Detail',
						key: 'outstandingPrincipalDetail',
						children: (
							<>
								<Table
									scroll={{ x: 'max-content' }}
									dataSource={
										outstandingPrincipalDetail?.map((record, key) => {
											return { ...record, key };
										}) ?? []
									}
									pagination={false}
									columns={[
										{
											title: 'No',
											render: (_, _record, index) => index + 1,
										},
										{
											title: 'Agreement No',
											dataIndex: 'agreementNo',
										},
										{
											title: 'Name',
											dataIndex: 'name',
										},
										{
											title: 'OS Principal',
											render: (_, record) =>
												record.osPrincipal
													? formatCurrency(record.osPrincipal)
													: '-',
										},
										{
											title: 'Agreement Date',
											dataIndex: 'agreementDate',
											render: (_, record) =>
												record.agreementDate
													? dayjs(record.agreementDate).format('DD MMM YYYY')
													: '-',
										},
										{
											title: 'Contract Status',
											dataIndex: 'contractStatus',
										},
									]}
								/>
							</>
						),
					},
				]}
			/>
			{/* <FleetTitle>Customer List</FleetTitle>
			<Table
				scroll={{ x: 'max-content' }}
				columns={customerListColumns}
				dataSource={data?.data?.customerList}
				pagination={false}
			/> */}
		</FleetModal>
	);
};

export default CustomerGroupDetailModal;

export const useCustomerGroupDetailModal = () => {
	return useState<CustomerGroupDetailModalState>(null);
};
